module.exports = __webpack_public_path__ + "static/media/pincode.c3570b3a.svg";